export const ReversLeftIcon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.33325 5.83333H11.6666C14.428 5.83333 16.6666 8.07191 16.6666 10.8333C16.6666 13.5948 14.428 15.8333 11.6666 15.8333H3.33325M3.33325 5.83333L6.66659 2.5M3.33325 5.83333L6.66659 9.16667"
      stroke="#0C111D"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
